<mat-form-field class="w-full">
  <mat-label>{{ label() }}</mat-label>

  <mat-select
    [formControl]="control()"
    name="food"
  >
    @for (option of options(); track option.value) {
      <mat-option [value]="option.value">{{ option.label }}</mat-option>
    }
  </mat-select>

  @if (control().invalid) {
    <mat-error>{{ errorMsg() }}</mat-error>
  }
</mat-form-field>
